<template>
  <section :class="[ 'detail-section', section.classes ]" :data-section-index="idx">
    <div :class="[ 'content', { 'fade-in': showContent } ]">
      <div :class="[ 'detail-instructions', { active: showOverlay } ]">
        <p
          class="font-regular text-size-35 fg-white"
          v-html="section.instructions"
        ></p>
        <div class="icon"></div>
      </div>

      <div v-if="showContent && showOverlay" class="overlay">
        <div
          v-for="item in section.items"
          :key="item.index"
          :class="[ 'focusable', 'hover', { active: focus && focus.index === item.index} ]"
          :style="getItemStyle(item)"
          @click.prevent="showFocus(item)"
        >
          <div class="image-wrapper">
            <img :src="item.source" :alt="item.label" draggable="false">
          </div>
          <div
            :class="[ 'label', `label-${item['label-position']}` ]"
            v-html="item.label"
            ></div>
        </div>

        <div v-if="section.continue" class="continue">
          <p class="font-semibold text-size-33 fg-white" v-html="section.continue"></p>
        </div>
      </div>

      <Transition>
        <DetailDisplay
          v-if="detail && showDetail"
          :key="detailKey"
          :detail="detail"
          :index="focus.index"
          @action="onAction"
        />
        <div v-else></div>
      </Transition>
    </div>

    <div
      :class="[ 'button', 'button-navigation', 'button-previous', { active: showBackButton } ]"
      @click.prevent="onClick"
    ></div>
  </section>
</template>
  
<script>
import DetailDisplay from '../partials/DetailDisplay'

export default {
  name: 'DetailSection',
  components: {
    DetailDisplay
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    idx: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showContent: false,
      showOverlay: false,
      showDetail: false,
      showBackButton: false,
      focus: null,
      detail: null,
      detailKey: 0,

      eventHandlers: {
        followPathway: this.followPathway,
      },
    }
  },
  methods: {
    getItemStyle(item) {
      const properties = [ 'top', 'left', 'width', 'height' ];
      let style = '';
      properties.forEach(prop => {
        if (item[prop] !== undefined) {
          style += `${prop}:${item[prop]}rem;`
        }
      });
      return style;
    },

    onAction(event) {
      if (event.type in this.eventHandlers) {
        return this.eventHandlers[event.type](event);
      }
      this.$emit('action', event);
    },
    followPathway(event) {
      setTimeout(() => this.clearFocus(), 500);
      this.$emit('action', event);
    },

    activateState() {
      this.showContent = true;
      this.showOverlay = true;
      this.$emit('action', { type: 'activateButton' });
    },
    showFocus(item) {
      this.focus = item;
      if (item.detail) {
        this.detail = item.detail;
        this.detailKey = Date.now();
        setTimeout(() => this.showDetail = true, this.section.delay * 1000);
      }
      this.showOverlay = false;
      this.$emit('action', { type: 'setNextButtonState', data: false });

      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: item.open,
          onEnded: () => {
            this.showBackButton = true;
            if (item.return) {
              this.$emit('action', { type: 'playChapter', data: item.return });
            }
          },
        }
      });
    },
    clearFocus() {
      this.showDetail = false;
      this.showBackButton = false;
      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: this.focus.close,
          onEnded: () => {
            this.focus = null;
            this.detail = null;
            this.showOverlay = true;
            this.$emit('action', { type: 'activateButton' });
          },
        }
      });
    },
    onClick() {
      this.clearFocus();
    }
  },
  mounted() {
    if (this.section.chapter !== null) {
      this.$emit('action', {
        type: 'playChapter', data: {
          chapter: this.section.chapter,
          onEnded: () => this.activateState(),
        }
      });
    } else {
      this.activateState();
    }
    this.$emit('action', { type: 'updateHeader', data: this.section['header-color'] });
  },
}
</script>
